<spa-tabs [routes]="routes()" />
